<template>
  <el-dialog
    :title="title"
    :visible.sync="dialogFormVisible"
    :close-on-click-modal="false"
    width="500px"
    @close="close"
  >
    <div style="margin-bottom: 20px">该工单是否确认提交？</div>
    <el-form ref="form" :model="form" :rules="rules" label-width="80px">
      <el-form-item label="内审人员" prop="auditUser">
        <el-select
          v-model="form.auditUser"
          placeholder="请选择内审人员"
          clearable
          filterable
        >
          <el-option
            v-for="item in investigateOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="小记" prop="note">
        <el-input
          v-model.trim="form.note"
          type="textarea"
          autocomplete="off"
        ></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="close">取 消</el-button>
      <el-button type="primary" :loading="loading" @click="save">
        确 定
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
  import {
    getUsersListByRole,
    submit,
  } from "@/api/workplace/supervison/orderRepair";
  import { mapGetters } from "vuex";
  import { getRoleKey } from "@/utils/index";

  export default {
    name: "Submit",
    data() {
      return {
        loading: false,
        form: {
          auditUser: "",
          surveyUser: "",
          note: "",
        },
        rules: {
          auditUser: [
            { required: true, trigger: "blur", message: "请选择内审人员" },
          ],
          note: [
            { required: true, message: "请输入小记", trigger: "blur" },
            {
              max: 500,
              message: "小记不能超过500个汉字",
              trigger: "blur",
            },
          ],
        },
        title: "",
        openLevel: 0,
        dialogFormVisible: false,
        investigateOptions: [],
        // 提交人员推荐参数
        parameter: {
          body: [],
          header: {
            currentTime: "2020-09-09 12:12:12",
            requestId: "1",
            sourceType: "site",
          },
        },
        obj: {
          console: "supervisor", // 固定写法
          note: null,
          operAction: "工单补充", // 固定写法
          projectSource: "",
          step: "督导工作台-工单补充-待处理", // 固定写法
          auidUser: null,
          userNo: "",
          userRoleNo: "",
          workOrderNo: null,
          procInsId: null,
          taskId: null,
          // 异步生成报告5个触发点参数
          triggerPoint: "",
        },
        param: {
          body: [
            {
              roleKey: "verify_people",
            },
          ],
          header: {
            currentTime: "2020-09-09 12:12:12",
            requestId: "1",
            sourceType: "site",
          },
        },
        object: null,
      };
    },
    computed: {
      ...mapGetters({
        userNo: "user/userNo",
        roles: "user/roles",
      }),
    },
    created() {
      this.obj.userNo = this.userNo;
      this.obj.userRoleNo = getRoleKey("supervisor", this.roles);
    },
    methods: {
      async showSubmit(row) {
        this.title = "提交工单";
        this.form = Object.assign({}, row[0]);
        this.dialogFormVisible = true;
        // 查询内审人员
        this.investigateOptions = (await getUsersListByRole(this.param)).body;

        this.object = row;

        this.parameter.body = [];
      },
      setOpenLevel(val) {
        this.openLevel = val;
      },
      close() {
        this.$refs["form"].resetFields();
        this.form = this.$options.data().form;
        this.dialogFormVisible = false;
        // this.$emit("refreshData");
      },
      save() {
        this.$refs["form"].validate(async (valid) => {
          if (valid) {
            this.loading = true;
            for (let i = 0; i < this.object.length; i++) {
              this.obj.auditUser = this.form.auditUser;
              this.obj.note = this.form.note;
              this.obj.procInsId = this.object[i].procInsId;
              this.obj.taskId = this.object[i].taskId;
              this.obj.projectSource = this.object[i].source;
              this.obj.workOrderNo = this.object[i].workOrderNo;
              this.obj.userNo = this.object[i].monitorUser;
              // 异步生成报告5个触发点，参数名称triggerPoint
              if ("Y" === this.object[i].isSurveyUser) {
                this.obj.triggerPoint = "supply_commit";
              } else {
                this.obj.triggerPoint = "";
              }
              this.parameter.body.push(Object.assign({}, this.obj));
            }
            const { header } = await submit(this.parameter);
            if ("1" === header.retCode) {
              this.$baseMessage(header.retMessage, "success");
            } else {
              this.$baseMessage(header.retMessage, "error");
            }

            this.$refs["form"].resetFields();
            this.dialogFormVisible = false;
            if (this.openLevel === 1) {
              //编辑页打开提交对话框
              this.$emit("close");
              this.$emit("refreshData");
            } else {
              //列表页打开提交对话框
              this.$emit("refreshData");
            }
            // this.$emit("close");
            this.form = this.$options.data().form;
            this.loading = false;
          } else {
            return false;
          }
        });
      },
    },
  };
</script>
<style scoped>
  .el-select,
  .el-cascader {
    width: 100%;
  }
</style>
